import React, { useMemo } from 'react';
import { generatePath, Redirect, useLocation, useParams, useRouteMatch } from 'react-router-dom';

import { isUrlNamesMatch, useCategoryState, useSportState } from '@atlas/core';
import { TournamentBreadcrumbSkeleton } from '@atlas/ui';

import { searchQuerySymbol } from 'common/constants';

import TournamentHeaderView from './TournamentHeaderView';

const TournamentHeaderSimplified = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const searchString = searchParams.get(searchQuerySymbol);

  const { name: sportName, urlName: sportUrlName } = useSportState();
  const {
    initialized,
    loading,
    name: categoryName,
    tournaments,
    urlName: categoryUrlName,
  } = useCategoryState();

  const { params, path } = useRouteMatch();
  const { tournamentName } = useParams();

  const tournament = useMemo(
    () => tournaments.find(({ urlName }) => isUrlNamesMatch(urlName, params.tournamentName)),
    [tournaments, params.tournamentName],
  );
  const generatedBackPath = useMemo(
    () =>
      generatePath(path, {
        categoryName: categoryUrlName,
        sportName: sportUrlName,
      }),
    [path, categoryUrlName, sportUrlName],
  );

  const backPath = `${generatedBackPath}${
    searchString ? `?${searchQuerySymbol}=${searchString}` : ''
  }`;

  if (!initialized && loading && tournamentName) {
    return (
      <div className="simplified-tournament-header-skeleton">
        <TournamentBreadcrumbSkeleton />
      </div>
    );
  }

  if (!tournament) {
    return <Redirect to={backPath} />;
  }

  return (
    <TournamentHeaderView
      backPath={backPath}
      categoryName={categoryName}
      sportName={sportName}
      tournament={tournament}
    />
  );
};

export default TournamentHeaderSimplified;
